"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Render3DSystem = void 0;
var realms_engine_1 = require("realms-engine");
var realms_three_1 = __importDefault(require("realms-three"));
var render3DGameObject_1 = require("./render3DGameObject");
var realms_three_utils_1 = require("realms-three-utils");
var Render3DSystem = /** @class */ (function (_super) {
    __extends(Render3DSystem, _super);
    function Render3DSystem(options) {
        var e_1, _a;
        var _b, _c, _d, _e, _f;
        var _this = _super.call(this, [render3DGameObject_1.Render3DGameObject], []) || this;
        _this.systemName = "Render3DSystem";
        _this.canvasCtx = null;
        _this.passes = [];
        _this.alpha = !!options.alpha;
        _this.scene = new realms_three_1.default.Scene();
        _this.width = (_b = options.width) !== null && _b !== void 0 ? _b : window.innerWidth;
        _this.height = (_c = options.height) !== null && _c !== void 0 ? _c : window.innerHeight;
        _this.canvas = options.canvas;
        _this.canvas.width = _this.width * window.devicePixelRatio;
        _this.canvas.height = _this.height * window.devicePixelRatio;
        _this.camera =
            options.camera ||
                new realms_three_1.default.PerspectiveCamera(45, _this.width / _this.height, 5, 20000);
        _this.outlinePass = new realms_three_1.default.STDLIB.OutlinePass(new realms_three_1.default.Vector2(_this.width, _this.height), _this.scene, _this.camera);
        _this.outlinePass.renderToScreen = true;
        _this.outlinePass.overlayMaterial.blending = realms_three_1.default.CustomBlending;
        _this.outlinePass.visibleEdgeColor = new realms_three_1.default.Color((_d = options.outlineColor) !== null && _d !== void 0 ? _d : "#00ff00");
        try {
            for (var _g = __values((_e = options.passes) !== null && _e !== void 0 ? _e : []), _h = _g.next(); !_h.done; _h = _g.next()) {
                var pass = _h.value;
                _this.passes.push(pass(_this.scene, _this.camera));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_h && !_h.done && (_a = _g.return)) _a.call(_g);
            }
            finally { if (e_1) throw e_1.error; }
        }
        // Use shared renderer
        _this.canvasCtx = _this.canvas.getContext("2d");
        if (options.orbitControls) {
            _this.orbitControls = new realms_three_1.default.STDLIB.OrbitControls(_this.camera, options.canvas);
        }
        if (options.cameraControls) {
            _this.cameraControls = new realms_three_utils_1.CameraControls(_this.camera, options.canvas, (_f = options.cameraControlsOptions) !== null && _f !== void 0 ? _f : {});
        }
        if (options.setUpScene !== undefined) {
            options.setUpScene(_this.scene, _this.camera);
        }
        return _this;
    }
    Render3DSystem.prototype.onAdd = function (realm) {
        var _a;
        (_a = this.cameraControls) === null || _a === void 0 ? void 0 : _a.subscribe();
    };
    /**
     * Updates the size of the render
     */
    Render3DSystem.prototype.updateSize = function (_a) {
        var width = _a.width, height = _a.height;
        this.width = width;
        this.height = height;
        this.outlinePass.resolution.set(width, height);
        this.camera.aspect = this.width / this.height;
        this.camera.updateProjectionMatrix();
        this.canvas.width = width * window.devicePixelRatio;
        this.canvas.height = height * window.devicePixelRatio;
    };
    Render3DSystem.prototype.onTargetGameObjectEnter = function (gameObject) {
        if (gameObject instanceof render3DGameObject_1.Render3DGameObject) {
            gameObject.addToScene(this.scene);
        }
    };
    Render3DSystem.prototype.onTargetGameObjectExit = function (gameObject) {
        if (gameObject instanceof render3DGameObject_1.Render3DGameObject) {
            gameObject.removeFromScene(this.scene);
        }
    };
    /*
     * Gets the THREE.Scene. Don't add Object3D through this unless you know what you are doing.
     * Rather add objects through the Render3DSystem
     */
    Render3DSystem.prototype.getThreeScene = function () {
        return this.scene;
    };
    Render3DSystem.prototype.processAfterStep = function (delta, realm) {
        var _a, _b;
        _super.prototype.processAfterStep.call(this, delta, realm);
        (_a = this.orbitControls) === null || _a === void 0 ? void 0 : _a.update();
        (_b = this.cameraControls) === null || _b === void 0 ? void 0 : _b.update();
        if (this.canvasCtx) {
            var outlineObjects = this.getTargetGameObjects().flatMap(function (gameObject) {
                if (gameObject instanceof render3DGameObject_1.Render3DGameObject && gameObject.outline) {
                    return gameObject.getThreeObject();
                }
                return [];
            });
            this.outlinePass.selectedObjects = outlineObjects;
            (0, realms_three_utils_1.renderSceneOnCanvas)({
                targetContext: this.canvasCtx,
                scene: this.scene,
                camera: this.camera,
                width: this.width,
                height: this.height,
                alpha: this.alpha,
                passes: __spreadArray(__spreadArray([], __read(this.passes), false), [this.outlinePass], false),
            });
        }
    };
    Render3DSystem.prototype.clean = function () {
        var _a;
        (_a = this.cameraControls) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    };
    return Render3DSystem;
}(realms_engine_1.System));
exports.Render3DSystem = Render3DSystem;
